import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InvoiceFilterState {
  FilterByPatient: string;
  InsuranceTypeId?: string;
  FilterByCaregiver: string;
  StartDate?: string;
  EndDate?: string;
  isLoading: boolean;
}

const initialState: InvoiceFilterState = {
  FilterByPatient: "",
  FilterByCaregiver: "",
  isLoading: false,
};

export const sliceInvoiceFilter = createSlice({
  name: "invoiceFilter",
  initialState,
  reducers: {
    setStartDate(state, action: PayloadAction<Date | null>) {
      if (action.payload) {
        const date = new Date(action.payload);
        date.setHours(0, 0, 0);
        state.StartDate = date.toISOString();
      } else {
        state.StartDate = "";
      }
    },

    setEndDate(state, action: PayloadAction<Date | null>) {
      if (action.payload) {
        const date = new Date(action.payload);
        date.setHours(23, 59, 59);
        state.EndDate = date.toISOString();
      } else {
        state.EndDate = "";
      }
    },
    setFilterByPatient: (state, action: PayloadAction<string>) => ({
      ...state,
      FilterByPatient: action.payload,
    }),

    setFilterByCaregiver: (state, action: PayloadAction<string>) => ({
      ...state,
      FilterByCaregiver: action.payload,
    }),

    setFilterByInsuranceType: (state, action: PayloadAction<string>) => ({
      ...state,
      InsuranceTypeId: action.payload,
    }),

    setIsLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isLoading: action.payload,
    }),

    resetData: () => {
      return initialState;
    },
  },
});

export const InvoiceFilterActions = sliceInvoiceFilter.actions;

export const ReducerInvoiceFilter = sliceInvoiceFilter.reducer;
export const ActionInvoiceFilter = sliceInvoiceFilter.actions;
